(() => {
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollTo = element => element?.scrollIntoView({behavior: reduceMotion() ? 'instant' : 'smooth', block: 'center'});
  if (!customElements.get('ee-product-sticky')) customElements.define('ee-product-sticky', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.main = document.getElementById('MainProduct-' + this.dataset.productSection);
      this.info = document.getElementById('ProductInfo-' + this.dataset.productSection);
      this.button = this.querySelector('[data-ee-sticky-submit]');
      if (!this.info || !this.button) return;
      this.update = () => {
        const native = this.info.querySelector('product-form button[name="add"]');
        if (this.native !== native) {
          this.observer?.disconnect(); this.native = native;
          if (native) {
            this.observer = new IntersectionObserver(entries => { this.past = entries[0].boundingClientRect.bottom < 0; this.visibility(); });
            this.observer.observe(native);
          }
        }
        this.button.disabled = !native || native.disabled || native.getAttribute('aria-disabled') === 'true' || native.classList.contains('loading');
        this.querySelector('[data-ee-sticky-label]').textContent = native?.querySelector('span')?.textContent.trim() || '';
        const price = this.info.querySelector('.price');
        const amount = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price-item--regular');
        this.querySelector('[data-ee-sticky-price]').textContent = amount?.textContent.trim() || '';
        if (this.pending && this.info.querySelector('.product-form__error-message')?.textContent.trim()) {
          this.pending = false; scrollTo(this.info.querySelector('.product-form__error-message-wrapper'));
        }
        this.visibility();
      };
      this.visibility = () => { this.hidden = !(this.native && this.past && matchMedia('(max-width:749px)').matches && !document.querySelector('cart-drawer.active,cart-notification.active,dialog[open],.product-media-modal[open]')); };
      this.mutations = new MutationObserver(this.update);
      this.mutations.observe(this.info,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
      this.button.addEventListener('click', () => {
        if (!this.native || this.button.disabled) return;
        const form = this.native.form;
        if (form && !form.reportValidity()) { scrollTo(this.info); return; }
        this.pending = true;
        this.native.click();
      },{signal:this.abort.signal});
      window.addEventListener('resize',this.visibility,{signal:this.abort.signal});
      this.drawerObserver = new MutationObserver(this.visibility);
      document.querySelectorAll('cart-drawer,cart-notification,.product-media-modal').forEach(el => this.drawerObserver.observe(el,{attributes:true,attributeFilter:['class','open']}));
      this.update();
    }
    disconnectedCallback(){this.abort?.abort();this.mutations?.disconnect();this.observer?.disconnect();this.drawerObserver?.disconnect();}
  });
  if (!customElements.get('ee-product-dots')) customElements.define('ee-product-dots', class extends HTMLElement {
    connectedCallback(){
      this.abort = new AbortController();
      this.slider = document.getElementById('GalleryViewer-' + this.dataset.productSection);
      this.list = document.getElementById('Slider-Gallery-' + this.dataset.productSection);
      if (!this.slider || !this.list) return;
      this.nav = document.createElement('nav');this.nav.className='ee-gallery-dots';this.nav.setAttribute('aria-label','Product images');
      this.slider.append(this.nav);
      this.rebuild = () => {
        const next = [...this.list.children].filter(el => el.matches('[id^="Slide-"]') && getComputedStyle(el).display !== 'none');
        if (this.items && next.length === this.items.length && next.every((el,i) => el === this.items[i])) { this.sync(); return; }
        this.items = next;
        this.nav.replaceChildren();
        this.items.forEach((item,i)=>{
          const button=document.createElement('button');button.type='button';button.setAttribute('aria-label','View product media '+(i+1));button.setAttribute('aria-controls',item.id);
          button.addEventListener('click',()=>this.list.scrollTo({left:item.offsetLeft-this.items[0].offsetLeft,behavior:reduceMotion()?'instant':'smooth'}));this.nav.append(button);
        });
        this.slider.classList.toggle('ee-dots-ready',this.items.length>1);this.nav.hidden=this.items.length<2;this.sync();
      };
      this.sync=()=>{
        if (!this.items?.length) return;
        const x=this.list.getBoundingClientRect().left;
        let selected=0,min=Infinity;this.items.forEach((el,i)=>{const d=Math.abs(el.getBoundingClientRect().left-x);if(d<min){min=d;selected=i;}});
        [...this.nav.children].forEach((b,i)=>b.setAttribute('aria-current',String(i===selected)));
      };
      this.list.addEventListener('scroll',this.sync,{passive:true,signal:this.abort.signal});
      this.mo=new MutationObserver(this.rebuild);this.mo.observe(this.list,{childList:true,subtree:true,attributes:true,attributeFilter:['class','hidden']});
      this.ro=new ResizeObserver(this.rebuild);this.ro.observe(this.list);this.rebuild();
    }
    disconnectedCallback(){this.abort?.abort();this.mo?.disconnect();this.ro?.disconnect();this.nav?.remove();this.slider?.classList.remove('ee-dots-ready');}
  });
  if (!customElements.get('ee-product-story')) customElements.define('ee-product-story',class extends HTMLElement {
    connectedCallback(){
      this.abort=new AbortController();const options={signal:this.abort.signal};
      const controls=this.querySelector('.ee-fit-controls');if(controls)controls.hidden=false;
      this.addEventListener('click',event=>{const button=event.target.closest('[data-ee-view]');if(!button)return;this.querySelectorAll('[data-ee-view]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.querySelectorAll('[data-ee-frame]').forEach(el=>el.hidden=el.dataset.eeFrame!==button.dataset.eeView);},options);
      this.querySelectorAll('.ee-hotspot').forEach(point=>point.addEventListener('toggle',()=>{
        if(!point.open)return;
        this.querySelectorAll('.ee-hotspot').forEach(other=>{if(other!==point)other.open=false;});
        const panel=point.querySelector('.ee-hotspot__content');panel.style.left='0';panel.style.top='48px';
        const rect=panel.getBoundingClientRect();const frame=this.querySelector('.ee-story__frame').getBoundingClientRect();
        panel.style.left=Math.min(0,frame.right-rect.right-8)+'px';
        if(rect.bottom>frame.bottom)panel.style.top=(-rect.height-4)+'px';
      },options));
      this.addEventListener('keydown',e=>{if(e.key==='Escape'){const open=this.querySelector('.ee-hotspot[open]');if(open){open.open=false;open.querySelector('summary').focus();}}},options);
      document.addEventListener('click',e=>{if(!this.contains(e.target))this.querySelectorAll('.ee-hotspot').forEach(p=>p.open=false);},options);
    }
    disconnectedCallback(){this.abort?.abort();}
  });
})();
